import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { useNotifyError } from '~/features/hooks/useNotifyError'
import { GET_VISITOR_QUERY_KEY } from '~/features/visitors/hooks/useGetVisitor'
import { supabaseApi } from '~/supabase/api'
import { Visitor } from '~/supabase/types'

export const useEditVisitor = () => {
  const { mutate: notifyError } = useNotifyError()
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['edit-visitor'] as const,
    mutationFn: async (payload: Partial<Visitor> & { id: Visitor['id'] }) => {
      const { error } = await supabaseApi.from('visitors').update(payload).eq('id', payload.id)

      if (error) {
        toast.error('Something went wrong check you console')
        notifyError({
          message: 'Something went wrong while editing visitor.',
          function: 'editVisitor',
          error,
          data: { formData: payload },
        })
        throw error
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_VISITOR_QUERY_KEY] })
    },
  })
}
